// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_kl-0";
export var fulfillmentPanelBody = "_kl-1";